import { tableTypes } from '@/shared/components';

export const scoreColumns: tableTypes.ColumnProps<any>[] = [
  {
    columnKey: 'std_id',
    title: 'Activity ID',
    width: '50%',
  },
  {
    columnKey: 'score',
    title: 'Score',
    width: '50%',
  },
];